module.exports = __webpack_public_path__ + "static/media/chatbot_bot_hover_icon.25ed5ec3.svg";